import { render } from "./loanDetailsPaymentModal.vue?vue&type=template&id=97c519d6"
import script from "./loanDetailsPaymentModal.vue?vue&type=script&lang=js"
export * from "./loanDetailsPaymentModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__